<template>
    <div class="footer font-adineue-regular text-sm text-white py-4 bg-black text-center">
        Made with ♥ by <a class="text-white inline-block no-underline border-b border-white" href="https://www.lahautesociete.com/" target="_blank">La Haute Société</a>
    </div>
</template>

<script>
    export default {
        name: "FooterComponent"
    }
</script>

<style scoped>

</style>